import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import { Dialog } from "primereact/dialog";
import { FC, useEffect, useState } from "react";
import { GALLERY_VIDEO } from "../../../../constants/constants";
import { useResponsive } from "../../../../responsive/ResponsiveProvider";
import { GallerySection } from "../../../../models/manageWebSite";
import EditModal from "./EditModal";

interface Section5Props {
  data: GallerySection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}
const Section5: FC<Section5Props> = ({ data, flag, setFlag, homeId }) => {
  const mobile = useResponsive().isMobile;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [showAll, setShowAll] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const images = data?.sectionSignedImg || [];

  console.log("Gallery section data:", data);

  const openGalleryLightbox = (index: number) => {
    setActiveImageIndex(index);
    setShowAll(true);
  };

  const showPreviousImage = () => {
    if (images.length === 0) {
      return;
    }
    setActiveImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const showNextImage = () => {
    if (images.length === 0) {
      return;
    }
    setActiveImageIndex((prev) => (prev + 1) % images.length);
  };

  useEffect(() => {
    if (!showAll) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        showPreviousImage();
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        showNextImage();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showAll, images.length]);

  return (
    <div id="12" style={{ width: "100%", padding: "3rem 1.25rem", background: "linear-gradient(180deg, #0f3d63 0%, #143f66 100%)" }}
      className="scroll-slide-section">
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        <div className="flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <div style={{ color: "rgba(255,255,255,0.76)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>
              Gallery
            </div>
            <div style={{ color: "#ffffff", fontSize: mobile ? "1.8rem" : "2.3rem", fontWeight: 800, marginTop: "0.65rem" }}>
              Inside the home
            </div>
            <div style={{ color: "rgba(255,255,255,0.82)", marginTop: "0.8rem", lineHeight: 1.8, maxWidth: "760px", whiteSpace: "pre-line" }}>
              {data?.description}
            </div>
          </div>
          <Button label="Edit Gallery" severity="warning" className="website-section-action-button" onClick={() => setOpenModal(true)} />
        </div>
        {
          images && images.length > 0 && (
            <div className="w-100 d-flex flex-column gap-3 justify-content-center align-items-center" style={{ padding: mobile ? "10px 0 0" : "18px 0 0" }}>
              <Carousel value={images} numVisible={mobile ? 1 : 3} numScroll={mobile ? 1 : 3} circular className="w-100" itemTemplate={(image) => {
                const imageIndex = images.indexOf(image);
                return (
                <div onClick={() => openGalleryLightbox(imageIndex >= 0 ? imageIndex : 0)} style={{ height: mobile ? "210px" : "280px", padding: "10px", cursor: "pointer" }}>
                  <div style={{ background: "#ffffff", borderRadius: "24px", overflow: "hidden", height: "100%", boxShadow: "0 20px 40px rgba(2, 8, 23, 0.22)" }}>
                    {
                      image && image.indexOf(GALLERY_VIDEO) !== -1 && (
                        <video width="100%" height="100%" style={{ objectFit: "cover" }} controls>
                          <source src={image} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      )
                    }
                    {
                      image && image.indexOf(GALLERY_VIDEO) === -1 && (
                        <img src={image} alt="Gallery" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      )
                    }
                  </div>
                </div>
              )}} />
            </div>)
        }

      <Dialog
        visible={showAll}
        onHide={() => setShowAll(false)}
        maximized
        focusOnShow={false}
        style={{ background: "#020617" }}
        contentStyle={{ background: "#020617", padding: 0 }}
        headerStyle={{ background: "#020617", color: "#ffffff", borderBottom: "1px solid rgba(255,255,255,0.08)" }}
        header={images.length > 0 ? `Gallery ${activeImageIndex + 1} of ${images.length}` : "Gallery"}
      >
        {images[activeImageIndex] ? (
          <div
            className="flex align-items-center justify-content-center"
            style={{ minHeight: "calc(100vh - 8rem)", gap: "1rem", padding: "1rem", background: "#020617" }}
          >
            <Button icon="pi pi-chevron-left" rounded outlined severity="contrast" autoFocus onClick={showPreviousImage} />
            <div className="flex align-items-center justify-content-center" style={{ flex: 1, height: "100%" }}>
              {images[activeImageIndex].indexOf(GALLERY_VIDEO) !== -1 ? (
                <video controls autoPlay style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "18px" }}>
                  <source src={images[activeImageIndex]} type="video/mp4" />
                </video>
              ) : (
                <img
                  src={images[activeImageIndex]}
                  alt={`Gallery ${activeImageIndex + 1}`}
                  style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain", borderRadius: "18px" }}
                />
              )}
            </div>
            <Button icon="pi pi-chevron-right" rounded outlined severity="contrast" onClick={showNextImage} />
          </div>
        ) : null}
      </Dialog >

      </div>
      <EditModal isOpen={openModal} toggleModal={setOpenModal} flag={flag} setFlag={setFlag} homeId={homeId} data={data} />
    </div >
  );
};

export default Section5;
